module.exports = __webpack_public_path__ + "static/media/FiraSans-Light.03422917.ttf";